import { StructuredLog } from "@agentx/agentx-services";
import { ensureError } from "@agentx/agentx-services/src/workers/workerImplementationUtils";
const LOGOUT_PARAMETER_KEY = "logout";
const LOGOUT_SESSION_STORAGE_KEY = "loginOut";
const LOGOUT_SESSION_STORAGE_VALUE = "true";
export function isIFrame() {
    return self !== window.top;
}
export function isSameOriginWindow(otherWindow) {
    if (!otherWindow || otherWindow.closed) {
        return false;
    }
    try {
        return otherWindow.location.origin === window.location.origin;
    }
    catch {
        return false;
    }
}
/** Returns whether the current window is handling an iframe logout request or its CI redirect callback. */
export function isIframedLogoutRequested(windowOpener) {
    const hasLogoutParameter = new URLSearchParams(window.location.search).has(LOGOUT_PARAMETER_KEY);
    const hasPendingLogout = sessionStorage.getItem(LOGOUT_SESSION_STORAGE_KEY) === LOGOUT_SESSION_STORAGE_VALUE;
    const hasWindowOpener = windowOpener !== null && windowOpener !== undefined;
    return hasWindowOpener && (hasLogoutParameter || hasPendingLogout);
}
/**
 *
 * @returns true if the new login flow for iframe is handled, false otherwise
 */
export function handleNewLoginFlowForIFrame(code, transactionId, state) {
    const openerWindow = window.opener;
    const isIFrameAuthenticationWindow = openerWindow !== null && !openerWindow.closed;
    if (!isIFrameAuthenticationWindow) {
        return false;
    }
    if (!code) {
        window.sessionStorage.setItem("iFrameLegacyLoginFlow", "true");
        return false;
    }
    if (window.sessionStorage.getItem("iFrameLegacyLoginFlow") === "true") {
        return false;
    }
    if (!transactionId || !state) {
        StructuredLog.trace("Login/IFrame/InvalidTransaction");
        window.close();
        return true;
    }
    openerWindow.postMessage({ type: "webex-auth-code", code, transactionId, state }, openerWindow.location.origin);
    return true;
}
function isPopup() {
    const openerWindow = window.opener;
    return !!(openerWindow && !openerWindow.closed);
}
export function handleNewIFrameLogout(refreshToken) {
    const logoutWindow = window.open(`${window.location.origin}?${LOGOUT_PARAMETER_KEY}=${refreshToken}`, "logout", "width=500,height=500");
    if (!logoutWindow) {
        StructuredLog.error("logout/iFrame/popupBlocked");
        return;
    }
    const logoutWindowCheckInterval = setInterval(() => {
        if (logoutWindow.closed) {
            clearInterval(logoutWindowCheckInterval);
            StructuredLog.debug("logout/iFrame/popupClosed");
            const TOKEN_KEY = "uuip-auth-token";
            const CLUSTER_ID_KEY = "clusterId";
            const CI_CONFIG_KEY = "ci-config";
            localStorage.removeItem(TOKEN_KEY);
            localStorage.removeItem(CLUSTER_ID_KEY);
            localStorage.removeItem(CI_CONFIG_KEY);
            window.location.reload();
        }
    }, 1000);
}
export function handleNewLogOutInIFramePopUp(authModule) {
    if (!isPopup()) {
        return false;
    }
    const searchParams = new URLSearchParams(window.location.search);
    const logoutValue = searchParams.get(LOGOUT_PARAMETER_KEY);
    const isNewFlow = logoutValue !== "'true'" && !!logoutValue;
    if (isNewFlow) {
        sessionStorage.setItem(LOGOUT_SESSION_STORAGE_KEY, LOGOUT_SESSION_STORAGE_VALUE);
        authModule.clearCustomerSessionData();
        authModule.authService.logout(logoutValue).catch((error) => {
            StructuredLog.error("logout/iFrame/logoutFailed", "Logout failed in popup window", { error: ensureError(error) });
        });
        return true;
    }
    if (sessionStorage.getItem(LOGOUT_SESSION_STORAGE_KEY) === LOGOUT_SESSION_STORAGE_VALUE) {
        sessionStorage.removeItem(LOGOUT_SESSION_STORAGE_KEY);
        window.close();
        return true;
    }
    return false;
}
